import React from "react";
import { Tooltip } from "@mui/material";

/**
 * A React component that truncates text to a specified length and displays a tooltip with the full text on hover.
 *
 * @param props - The props for the TruncatedText component.
 * @param props.text - The text to display, which may be truncated.
 * @param props.maxLength - The maximum length of the text before truncation (default: 25).
 * @returns A React component rendering either the full text or a truncated version with a tooltip.
 */
const TruncatedText: React.FC<{ text: string; maxLength?: number }> = ({ text, maxLength = 25 }) => {
  if (text.length <= maxLength) {
    return <span>{text}</span>;
  }

  return (
    <Tooltip title={text} placement="top">
      <span>{text.substring(0, maxLength)}...</span>
    </Tooltip>
  );
};

export default TruncatedText;
